const MEDIA_ITEMS = [
  {
    title: '本周热门精选',
    desc: '编辑团队精心挑选的本周最受欢迎视频合集，涵盖影视解说、搞笑日常、美食探店等多元类型。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20with%20warm%20coral%20and%20dark%20theme%2C%20film%20reel%20abstract%20design%2C%20soft%20glow%20highlights%2C%20movie%20night%20atmosphere%2C%20entertainment%20content%20vibe%2C%20modern%20streaming%20aesthetic%2C%20no%20text&width=800&height=450&seq=media-card-01&orientation=landscape',
    views: '128.6万',
    tag: '精选',
  },
  {
    title: '新片速递频道',
    desc: '第一时间上架最新影视资源，与主流平台同步更新，追剧不再等待。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20film%20strip%20abstract%20design%20with%20warm%20amber%20gradient%2C%20cinematic%20lighting%2C%20soft%20focus%20background%2C%20elegant%20entertainment%20theme%2C%20streaming%20platform%20visual%2C%20no%20text%2C%20dark%20warm%20tones&width=800&height=450&seq=media-card-02&orientation=landscape',
    views: '95.3万',
    tag: '新片',
  },
  {
    title: '经典回顾专区',
    desc: '收录历年经典影片与热门综艺，支持高清回看，重温那些不可错过的精彩瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20nostalgic%20tones%2C%20classic%20movie%20theme%2C%20soft%20coral%20and%20gold%20accents%2C%20retro%20cinema%20vibe%2C%20elegant%20abstract%20composition%2C%20no%20text&width=800&height=450&seq=media-card-03&orientation=landscape',
    views: '76.8万',
    tag: '经典',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line text-sm"></i>
            热门频道
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            精选视频专区
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
            多个特色频道满足不同观影口味，每日更新
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 text-background-50/90 text-xs">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-foreground-950 text-sm mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}